module.exports = __webpack_public_path__ + "img/raffle-banner.c1c8fbb5.jpg";